var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "700"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var button = _ref.on;
        return [_c('v-tooltip', {
          attrs: {
            "left": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref2) {
              var tooltip = _ref2.on;
              return [_c('v-fade-transition', [_vm.somethingChecked ? _c('v-btn', _vm._g({
                attrs: {
                  "id": "delete-workspaces",
                  "block": "",
                  "tile": "",
                  "dark": "",
                  "color": "red accent-3"
                },
                on: {
                  "click": button.click
                }
              }, tooltip), [_vm._v(" Delete Selected "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v(" mdi-delete-sweep ")])], 1) : _vm._e()], 1)];
            }
          }], null, true)
        }, [_c('span', [_vm._v("Delete selected")])])];
      }
    }]),
    model: {
      value: _vm.dialog,
      callback: function ($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline pb-0 pt-3 px-5",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v(" Delete Workspaces ")]), _c('v-card-text', {
    staticClass: "px-5 py-4"
  }, [_vm._v(" You are about to delete " + _vm._s(_vm.selection.length) + " workspace" + _vm._s(_vm.plural) + _vm._s(_vm.detail) + ". Type the following phrase to confirm: "), _c('strong', [_vm._v(_vm._s(_vm.confirmationPhrase))])]), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "autofocus": "",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.confirmation,
      callback: function ($$v) {
        _vm.confirmation = $$v;
      },
      expression: "confirmation"
    }
  })], 1), _c('v-divider'), _c('v-card-actions', {
    staticClass: "px-4 py-3"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "id": "delete-workspace-yes",
      "depressed": "",
      "color": "error",
      "disabled": _vm.confirmation !== _vm.confirmationPhrase
    },
    on: {
      "click": _vm.execute
    }
  }, [_vm._v(" yes ")]), _c('v-btn', {
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function ($event) {
        _vm.dialog = false;
      }
    }
  }, [_vm._v(" cancel ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }